import request from '@/utils/request'

// 查询微信配置列表
export function getWxKeyList(params) {
  return request({
    url: '/manager/wxKeyConfig/getWxKey',
    method: 'get',
    params
  })
}

// 添加修改微信配置
export function addWxKeyConfig(data) {
  return request({
    url: '/manager/wxKeyConfig/addWxKeyConfig',
    method: 'post',
    data
  })
}

// 删除微信配置
export function deleteWxKey(data) {
  return request({
    url: '/manager/wxKeyConfig/delectWxKey',
    method: 'post',
    data
  })
}

// 查询微信模版
export function selectWxTemplateByTenantId(params) {
  return request({
    url: '/manager/wxKeyConfig/selectWxTemplateByTenantId',
    method: 'get',
    params
  })
}

// 同步微信模版
export function obtainWxTemplate() {
  return request({
    url: '/manager/wxKeyConfig/obtainWxTemplate',
    method: 'get'
  })
}

// 修改模版启用状态（GET：id、isApply）
export function updateWxTemplateIsApply(params) {
  return request({
    url: '/manager/wxKeyConfig/updateWxTemplateIsApply',
    method: 'get',
    params
  })
}

// 同步微信基本信息
export function sysWxInfo() {
  return request({
    url: '/manager/wxKeyConfig/sysWxInfo',
    method: 'get'
  })
}

// 获取微信推送日志
export function getPushMsgList(params) {
  return request({
    url: '/manager/wxPushLogApi/getPushMsgList',
    method: 'get',
    params
  })
}

// 获取微信推送日志详情
export function getPushMsgDetails(params) {
  return request({
    url: '/manager/wxPushLogApi/getPushMsgDetails',
    method: 'get',
    params
  })
}

// 删除微信推送日志
export function deletePushMsg(data) {
  return request({
    url: '/manager/wxPushLogApi/delectPushMsg',
    method: 'post',
    data
  })
}

// 发送微信通知
export function sendWxPushMsg(data) {
  return request({
    url: '/manager/wxPushLogApi/wxPushMsgNoEvents',
    method: 'post',
    data
  })
}
